import { render, staticRenderFns } from "./TestKunden.vue?vue&type=template&id=6cf1255e&scoped=true&"
import script from "./TestKunden.vue?vue&type=script&lang=js&"
export * from "./TestKunden.vue?vue&type=script&lang=js&"
import style0 from "./TestKunden.vue?vue&type=style&index=0&id=6cf1255e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf1255e",
  null
  
)

export default component.exports